import { State } from '@progress/kendo-data-query';
import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { isEmpty } from 'lodash';
import { FC, useCallback, useMemo, useState } from 'react';
import ClearFilterButton from 'src/components/design-system/ClearFilterButton';
import ExportExcel, { defaultExcelOption } from 'src/components/ExportExcel';
import useViewCheckbook from 'src/hooks/useViewCheckbook';
import { ClientResponse } from 'src/services/useGetClientApi';

interface GridToolbarProps {
  excelExport: (data: any[], isIncluded?: boolean) => void;
  rows: ClientResponse[];
  allPageData: ClientResponse[];
  handleClearFilter: () => void;
  dataState: State;
}

const GLCodeApprovalAssignedUsersTableToolbar: FC<GridToolbarProps> = ({
  excelExport,
  rows,
  allPageData,
  handleClearFilter,
  dataState,
}) => {
  const [excelOption, setExcelOption] = useState(defaultExcelOption);
  const { selectedCompany } = useViewCheckbook();

  const { companyName } = selectedCompany;

  const handleExcelChange = useCallback(
    (e: DropDownListChangeEvent) => {
      const selectedOption = e.target.value;
      setExcelOption(selectedOption);
      if (selectedOption.value === 1) {
        excelExport(rows.map((row) => ({ ...row, companyName })));
        setExcelOption(defaultExcelOption);
      } else if (selectedOption.value === 2) {
        excelExport(allPageData.map((row) => ({ ...row, companyName })));
        setExcelOption(defaultExcelOption);
      }
    },
    [allPageData, companyName, excelExport, rows]
  );
  const isFilterDisable = useMemo(() => isEmpty(dataState?.filter), [dataState?.filter]);
  return (
    <div className="flex items-center justify-between w-full">
      <ClearFilterButton disabled={isFilterDisable} onClick={handleClearFilter} />
      <ExportExcel excelOption={excelOption} onExcelChanged={handleExcelChange} width={200} />
    </div>
  );
};
export default GLCodeApprovalAssignedUsersTableToolbar;
